import Cookie from 'js-cookie';

export default class App {
    static currencySwitcher(selector, _parent, ct_selector) {
        let parent = $(_parent);
        let toggle = $('.dropdown-toggle', parent);

        $(parent).on('click', selector, function (e) {
            let t = $(this);
            Cookie('CURRENCY', t.data('currency'), {expires: 30, path: '/'})
            $('.text', toggle).text($('.text', t).text());
            $('.symbol', toggle).text($('.symbol', t).text());
            $('.active.disabled', parent).removeClass('active disabled')
            t.parent('li').addClass('active disabled')

            if (window.jQCT !== undefined && jQCT(ct_selector.length)) {
                jQCT(ct_selector).val(t.data('currency')).change()
            } else {
                let form = $('#change-currency');
                form.append('<input type="hidden" name="currency" value="' + t.data('currency') +'">');
                form.append('<input type="hidden" name="url" value="' + window.location.href +'">');
                form.submit();
            }
            e.preventDefault();
        });
    }
} 